import './gsap-setup.js'
import Collapse from 'bootstrap/js/dist/collapse';
import Home from './pages/Home'
import Sliders from './components/Sliders'
import setVhUnit from './utils/set-vh'
import Header from './components/Header'
import QueryResult from './components/QueryResult.js';
import mask from './utils/mask.js';
import About from './pages/About.js';
(function () {
  'use strict'

  document.addEventListener('DOMContentLoaded', event => {
    About();
    Header()
    Home()
    QueryResult();
    Sliders()
    setVhUnit()
    QueryResult();

    mask('.mask-cnpj', '##.###.###/####-##');
  });
})();
